import DOMPurify from 'dompurify'

/**
 * Sanitização do HTML que vem do editor de conteúdo.
 *
 * As descrições de curso, módulo e episódio são escritas por admin no
 * TipTap e chegam como HTML, que o `HtmlContent` injeta via
 * `dangerouslySetInnerHTML`. Sem sanitizar, um admin de empresa consegue
 * plantar script na descrição de um curso e executá-lo no navegador de
 * quem abrir aquele curso — inclusive de um super_admin. Como o token de
 * acesso fica em localStorage, isso vira sequestro de sessão.
 *
 * A allowlist abaixo é o que a barra de ferramentas do editor consegue
 * produzir (`rich-text-editor.tsx`) mais o padrão do StarterKit. Nenhum
 * atributo é permitido: não há extensão de Link nem de Image instalada,
 * então href, src, style e class não têm origem legítima aqui.
 */
const TAGS_PERMITIDAS = [
  'p',
  'br',
  'strong',
  'b',
  'em',
  'i',
  's',
  'code',
  'pre',
  'h1',
  'h2',
  'h3',
  'ul',
  'ol',
  'li',
  'blockquote',
  'hr',
]

export function sanitizeHtml(html: string): string {
  // KEEP_CONTENT fica no padrão (true): o texto de uma tag não permitida é
  // preservado, o que evita sumir com o conteúdo legítimo de um <div> antigo.
  // O corpo de <script> e <style> some de qualquer forma — eles estão em
  // FORBID_CONTENTS por padrão no DOMPurify.
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: TAGS_PERMITIDAS,
    ALLOWED_ATTR: [],
  })
}

/**
 * Escapa texto puro para interpolar dentro de HTML.
 *
 * `Episode.tsx` monta uma string com o título do módulo dentro de tags. O
 * título não passa pelo editor — é campo de texto simples —, então precisa
 * ser escapado antes de virar HTML, senão continua sendo vetor de injeção
 * mesmo com a descrição sanitizada.
 */
export function escapeHtml(texto: string): string {
  return texto
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}
